import { render, staticRenderFns } from "./SDS-rate-widget.vue?vue&type=template&id=3e0dbee8"
import script from "./SDS-rate-widget.vue?vue&type=script&lang=js"
export * from "./SDS-rate-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports